import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LabMDM } from "./models/lab";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { BBResponseContainer } from "../carrier/response-container";
import { CarrierState } from "./models/carrierState";
import { QcType } from "./models/qcType";
import { BusinessArea } from "./models/businessArea";
import { Machine } from "./models/machine";
import { Printer } from "./models/printer";
import { SeqConfig } from "./models/seqConfig";
import { Chemical } from "./models/chemical";
import { MachineType } from "./models/machineType";
import { Product } from "./models/product";
import { ChemicalCategory } from "./models/chemicalCatagory-enum";
import { LibType } from "./models/libType";
import { EchoConfig } from "./models/echoConfig";
import { SalesItemTypeConfig } from "./models/salesitemtype-config";
import { tap, timeout } from 'rxjs/operators';
import { StandardPrimer } from './models/standardPrimer';
import { Template } from './models/template';
import { SenderDTO } from './models/sender-dto';
import { KitsDTO } from './models/kits-dto';
import { ResultConfigDTO } from '../mdm-result-engine-config/model/result-config-dto';
import { ExternalSenderLoginDTO } from "./models/externalSenderLogin";
import { Manufacturers } from "./models/manufacturers";
import { RedoReason } from "./models/redoReason";
import { InboundFileProcessing } from "./models/inboundFileProcessing";
import { Controls } from "./models/controls";


//Service used for crud opertaions on the master data
@Injectable()
export class MasterDataService {

    readonly LABMDMSERVICE = 'admin/mdm/lab';
    readonly BAMDMSERVICE = 'admin/mdm/ba';
    readonly QCTYPEMDMSERVICE = 'admin/mdm/qctype';
    readonly MACHINEMDMSERVICE = 'admin/mdm/machine';
    readonly PRINTERMDMSERVICE = 'admin/mdm/printer';
    readonly CARRIERSTATEMDMSERVICE = 'admin/mdm/carrier/state'
    readonly GETCOUNTRIESURL = 'admin/mdm/country'
    readonly SEQCONFIGMDMSERVICE = 'admin/mdm/seqConfig';
    readonly CHEMICALMDMSERVICE = 'admin/mdm/chemical';
    readonly HELATHCHECK = 'health_check';
    readonly MACHINETYPEMDMSERVICE = 'admin/mdm/machinetype';
    readonly PRODUCTMDMSERVICE = 'admin/mdm/product';
    readonly PRODUCTMDMSERVICEBMS = 'admin/mdm/product/bmsProductName';
    readonly ACCESSLOG = 'admin/mdm/accesslog';
    readonly LIBTYPEMDMSERVICE = 'admin/mdm/libtype';
    readonly ECHOCONFIGURATION = 'admin/mdm/echoConfig';
    readonly SITCONFIGURATION = 'admin/mdm/salesItemType';
    readonly STANDARDPRIMER = 'admin/mdm/primer/standard';
    readonly TEMPLATEMDMSERVICE = 'admin/mdm/print/template';
    readonly SENDERMDMSERVICE = 'admin/mdm/sender';
    readonly KITMDMSERVICE = 'admin/mdm/kits';
    readonly PROBLEMCATEGORYMDMSERVICE = 'admin/mdm/problemcategory';
    readonly PROBLEMMDMSERVICE = 'admin/mdm/problem';
    readonly RESULTPROCESSMDMSERVICE = 'admin/mdm/result-process';
    readonly RESULTENGINECONFIGSERVICE = 'admin/mdm/resultConfig';
    readonly EXTERNALSENDERLOGINSERVICE = 'admin/mdm/eslogin';
    readonly MANUFACTURERSERVICE = 'admin/mdm/machine/manufacturer';
    readonly REDOREASON='admin/mdm/redoReason';
    readonly INBOUNDFILEPROCESSING = 'admin/mdm/inboundFileProcessing';
    readonly GENERIC_MDM_WORKFLOW='admin/mdm/generic';
    readonly ADMIN_MDM_GENERIC = 'admin/mdm/generic';
    readonly GENERIC_MDM = 'mdm/generic';
    readonly GENERIC_MDM_BATCHSTATUS = '/admin/mdm/generic';
    readonly GENERIC_MDM_PARENTAGE = '/admin/mdm/generic';

    constructor(private http: HttpClient) {
    }

    //Gets a list of labs
    getLabs(active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.LABMDMSERVICE;
        let requestParam = new HttpParams().set('active', active.toString());

        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of labs based on selected lab
    getLabsBasedOnSelectedLabForAppliedGenomics(lab: LabMDM): Observable<BBResponseContainer> {

        let url = environment.BB_MDMSERVICE_URL + this.LABMDMSERVICE + "/filter";
        let requestParam = new HttpParams().set('labId', lab._id);

        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }


    //getLabsWithOptionalHistory
    getLabsWithOptionalHistory(active: boolean, includeHistory: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.LABMDMSERVICE;
        let requestParam = new HttpParams().set('active', active.toString())
            .set('includeHistory', includeHistory.toString());

        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Creates a new Lab
    addLab(lab: LabMDM) {
        let url: string = environment.BB_MDMSERVICE_URL + this.LABMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, lab).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    //updates a lab
    updateLab(lab: LabMDM) {
        let url: string = environment.BB_MDMSERVICE_URL + this.LABMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, lab).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of carrierStates
    getCarrierStates(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.CARRIERSTATEMDMSERVICE;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    //Creates a new carrierState
    addCarrierState(carrierState: CarrierState) {
        let url: string = environment.BB_MDMSERVICE_URL + this.CARRIERSTATEMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, carrierState).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //updates a carrierState
    updateCarrierState(carrierState: CarrierState) {
        let url: string = environment.BB_MDMSERVICE_URL + this.CARRIERSTATEMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, carrierState).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of qctypes
    getQCTypes(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.QCTYPEMDMSERVICE;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Creates a new qcType
    addQcType(qcType: QcType) {
        let url: string = environment.BB_MDMSERVICE_URL + this.QCTYPEMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, qcType).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    //updates a qcType
    updateQcType(qcType: QcType) {
        let url: string = environment.BB_MDMSERVICE_URL + this.QCTYPEMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, qcType).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of machines
    getMachines(lab: LabMDM): Observable<BBResponseContainer> {

        if(lab.businessArea.name==="Applied Genomics") {

            let url = environment.BB_MDMSERVICE_URL + this.MACHINEMDMSERVICE+ "/covid";
            let requestParam = new HttpParams().set('labId', lab._id);

            const options = url ? { params: requestParam } : {};
            return this.http.get<BBResponseContainer>(url,options).pipe(tap(event => { }, error => {
                error.url = url;
            }));

        } else {
            let url = environment.BB_MDMSERVICE_URL + this.MACHINEMDMSERVICE;
            return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
                error.url = url;
            }));
        }
    }
    //Creates a new machine
    addMachine(machine: Machine) {
        let url: string = environment.BB_MDMSERVICE_URL + this.MACHINEMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, machine).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    //updates a machine
    updateMachine(machine: Machine) {
        let url: string = environment.BB_MDMSERVICE_URL + this.MACHINEMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, machine).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of printers
    getPrinters(active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PRINTERMDMSERVICE;
        let emptyRequestParam = new HttpParams();
        let requestParam = (active) ? new HttpParams().set('active', active.toString()): emptyRequestParam;
        const options = url ? { params: requestParam } : {};

        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    //Creates a new printer
    addPrinter(printer: Printer) {
        let url: string = environment.BB_MDMSERVICE_URL + this.PRINTERMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, printer).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    //updates a printer
    updatePrinter(printer: Printer) {
        let url: string = environment.BB_MDMSERVICE_URL + this.PRINTERMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, printer).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of businessArea
    getBusinessAreas(active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.BAMDMSERVICE;
        let requestParam = new HttpParams().set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    //Creates a new businessArea
    addBusinessArea(businessArea: BusinessArea) {
        let url: string = environment.BB_MDMSERVICE_URL + this.BAMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, businessArea).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    //updates a businessArea
    updateBusinessArea(businessArea: BusinessArea) {
        let url: string = environment.BB_MDMSERVICE_URL + this.BAMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, businessArea).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of sequencer Configurations
    getSeqConfigs(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.SEQCONFIGMDMSERVICE;
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Creates a new sequencer Configuration
    addSeqConfig(seqConfig: SeqConfig) {
        let url: string = environment.BB_MDMSERVICE_URL + this.SEQCONFIGMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, seqConfig).pipe(timeout(environment.defaultTimeout),tap(event => { console.log("success"); }, error => {
            console.log("error");
            error.url = url;
        }));
    }

    //Updates a sequencer Configuration
    updateSeqConfig(seqConfig: SeqConfig) {
        let url: string = environment.BB_MDMSERVICE_URL + this.SEQCONFIGMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, seqConfig).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    //Gets a list of countries
    getCountries(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.GETCOUNTRIESURL;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of chemicals
    getChemicals(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.CHEMICALMDMSERVICE;
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Creates a new chemical
    addChemical(chemical: Chemical) {
        let url: string = environment.BB_MDMSERVICE_URL + this.CHEMICALMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, chemical).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    //updates a chemical
    updateChemical(chemical: Chemical) {
        let url: string = environment.BB_MDMSERVICE_URL + this.CHEMICALMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, chemical).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Retrives all service health information
    getHealthStatus(): Observable<any> {
        let url: string = environment.BB_APIGATEWAY_SERVICE_URL + this.HELATHCHECK;
        return this.http.get<any>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    //Gets a list of machinetypes
    getMachineTypes(active: boolean, lab: LabMDM): Observable<BBResponseContainer> {
        if(lab && lab.businessArea.name==="Applied Genomics") {
            let url = environment.BB_MDMSERVICE_URL + this.MACHINETYPEMDMSERVICE + "/covid";
            let requestParam = new HttpParams().set('active', active.toString()).set("labId",lab._id);
            const options = url ? { params: requestParam } : {};
            return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
                error.url = url;
            }));

        } else {

        let url = environment.BB_MDMSERVICE_URL + this.MACHINETYPEMDMSERVICE;
        let requestParam = new HttpParams().set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    }

    //Creates a new machineType
    addMachineType(machineType: MachineType) {
        console.log("adding machineType Object : "+machineType);
        let url: string = environment.BB_MDMSERVICE_URL + this.MACHINETYPEMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, machineType).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //updates a machineType
    updateMachineType(machineType: MachineType) {
        let url: string = environment.BB_MDMSERVICE_URL + this.MACHINETYPEMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, machineType).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of product
    getProducts(active: boolean, lab : string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.ADMIN_MDM_GENERIC + "/" + lab + "/product/list";
        let requestParam = new HttpParams().set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Creates a new product
    addProduct(product: Product, lab : string) {
        let url: string = environment.BB_MDMSERVICE_URL + this.ADMIN_MDM_GENERIC + "/" + lab + "/" + "product";
        return this.http.post<BBResponseContainer>(url, product).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //updates a product
    updateProduct(product: Product,  lab : string) {
        let url: string = environment.BB_MDMSERVICE_URL + this.ADMIN_MDM_GENERIC + "/" + lab + "/" + "product" + "/" + product._id;
        return this.http.put<BBResponseContainer>(url, product).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    getProductsByLab(labId: string, active: boolean){
        let url: string = environment.BB_MDMSERVICE_URL + this.ADMIN_MDM_GENERIC + '/labId/' + labId ;
        let requestParam = new HttpParams().set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    //to get sales item type
    getSalesItemType(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.SITCONFIGURATION;
        return this.http.get<any>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    //to get sales item type
    getSalesItemTypeFilteredByLab(labId: string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.SITCONFIGURATION + '/labId/' + labId ;
        return this.http.get<any>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //to get sales item type
    getBmsProductName(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PRODUCTMDMSERVICEBMS;
        return this.http.get<any>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //to get access log
    getAccessLog(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.ACCESSLOG;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of buffer Chemicals
    getActiveBufferChemicals(active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.CHEMICALMDMSERVICE;
        let requestParam = new HttpParams().set('active', active.toString())
                                           .set('category', ChemicalCategory.BUFFER);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of libtype
    getLibTypes(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.LIBTYPEMDMSERVICE;
        return this.http.get<any>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Creates a new libtype
    addLibType(libtype: LibType) {
        let url: string = environment.BB_MDMSERVICE_URL + this.LIBTYPEMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, libtype).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //updates a libtype
    updateLibType(libtype: LibType) {
        let url: string = environment.BB_MDMSERVICE_URL + this.LIBTYPEMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, libtype).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of echo configurations
     getEchoCofigs(active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.ECHOCONFIGURATION;
        let requestParam = new HttpParams().set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Creates a new echo configuration
    addEchoConfig(echoConfig: EchoConfig) {
        let url: string = environment.BB_MDMSERVICE_URL + this.ECHOCONFIGURATION;
        return this.http.post<BBResponseContainer>(url, echoConfig).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    addSITConfiguration(salesItemTypeConfig: SalesItemTypeConfig){
        let url: string = environment.BB_MDMSERVICE_URL + this.SITCONFIGURATION;
        return this.http.post<BBResponseContainer>(url, salesItemTypeConfig).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //updates a echo configuration
    updateEchoConfig(echoConfig: EchoConfig) {
        let url: string = environment.BB_MDMSERVICE_URL + this.ECHOCONFIGURATION;
        return this.http.put<BBResponseContainer>(url, echoConfig).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    updateSITConfiguration(salesItemTypeConfig: SalesItemTypeConfig){
        let url: string = environment.BB_MDMSERVICE_URL + this.SITCONFIGURATION;
        return this.http.put<BBResponseContainer>(url, salesItemTypeConfig).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

     restartJobSchedularService() {
         let url = environment.BB_ORDER_CREATION_SCHEDULER_URL + 'restart';
         return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
             error.url = url;
         }));
     }

    //TO trigger job on given product
    triggerJob(salesItemTypeConfig: SalesItemTypeConfig) {
        let url: string = environment.BB_ORDERRECEPTION_SERVICE_URL + 'order/createOrder';
        return this.http.post<BBResponseContainer>(url, salesItemTypeConfig).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    getStandardPrimer(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.STANDARDPRIMER;
        return this.http.get<any>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    updateStandardPrimer(standardPrimer: StandardPrimer): any {
        let url: string = environment.BB_MDMSERVICE_URL + this.STANDARDPRIMER;
        return this.http.put<BBResponseContainer>(url, standardPrimer).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    addStandardPrimer(standardPrimer: StandardPrimer): any {
        let url: string = environment.BB_MDMSERVICE_URL + this.STANDARDPRIMER;
        return this.http.post<BBResponseContainer>(url, standardPrimer).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Insert a template
    addTemplate(template: Template) {
        let url: string = environment.BB_MDMSERVICE_URL + this.TEMPLATEMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, template).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        }));
    }

    //Update a template
    updateTemplate(template: Template) {
        let url: string = environment.BB_MDMSERVICE_URL + this.TEMPLATEMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, template).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Get all the templates from DB
    getTemplates(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.TEMPLATEMDMSERVICE;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Get all the templates from DB
    getSenders(lab: LabMDM): Observable<BBResponseContainer> {

        let url = environment.BB_MDMSERVICE_URL + this.SENDERMDMSERVICE;
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Get the Active Templates from Master DB For passed lab
    getActiveTemplatesForLab(lab: LabMDM, active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.TEMPLATEMDMSERVICE;
        let requestParam = new HttpParams().set('labId', lab._id).
                                            set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
      }

    addSender(sender: SenderDTO) {
        let url: string = environment.BB_MDMSERVICE_URL + this.SENDERMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, sender).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        }));
    }

    updateSender(sender: SenderDTO) {
        let url: string = environment.BB_MDMSERVICE_URL + this.SENDERMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, sender).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    getMapOfSenders(labId: string, active: boolean): Observable<BBResponseContainer> {

        let url = environment.BB_MDMSERVICE_URL + this.SENDERMDMSERVICE + "/mapOfSenders";
        let requestParam = new HttpParams().set('labId', labId).set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
      }

    addKit(kit: KitsDTO,machineImage:File) :  Observable<BBResponseContainer>{
        let url: string = environment.BB_MDMSERVICE_URL + "admin/mdm/kits-image?insert="+true;
        let formData:FormData = new FormData();
        formData.append('uploadFile', machineImage);
        formData.append('kit', new Blob([JSON.stringify(kit)],{type: "application/json"}));
        return this.http.post<BBResponseContainer>(url, formData).pipe(timeout(environment.defaultTimeout));
    }

    updateKit(kit: KitsDTO,machineImage:File) : Observable<BBResponseContainer> {
        let url: string = environment.BB_MDMSERVICE_URL + "admin/mdm/kits-image?insert="+false;
        let formData:FormData = new FormData();
        formData.append('uploadFile', machineImage);
        formData.append('kit', new Blob([JSON.stringify(kit)],{type: "application/json"}));
        return this.http.post<BBResponseContainer>(url, formData).pipe(timeout(environment.defaultTimeout));
    }

    //Get all the templates from DB
    getKits(lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.KITMDMSERVICE;
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url,options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    getMachineSubTypes(machineType: string, labId: string) {
        let url = environment.BB_MDMSERVICE_URL + this.MACHINEMDMSERVICE + '/subTypes/' + machineType + '/' + labId + '/' + true ;
        return this.http.get<any>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    getProblemCategory(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PROBLEMCATEGORYMDMSERVICE;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    getProblemCategoriesList(lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PROBLEMCATEGORYMDMSERVICE + '/all';
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url,options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    getActiveProblemCategoriesList(lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PROBLEMCATEGORYMDMSERVICE + '/'+lab._id+ '/' +true;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    getProblemList(lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PROBLEMMDMSERVICE + '/all';
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url,options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    getResultProcessList(lab: LabMDM): Observable<BBResponseContainer> {
      let url = environment.BB_MDMSERVICE_URL + this.RESULTPROCESSMDMSERVICE;
      let requestParam = new HttpParams().set('labId', lab._id);
      const options = url ? { params: requestParam } : {};
      return this.http.get<BBResponseContainer>(url,options).pipe(tap(event => { }, error => {
          error.url = url;
      }));
  }

  findLabById(selectedLabId: string): Observable<BBResponseContainer> {
    let url = environment.BB_MDMSERVICE_URL + this.LABMDMSERVICE + "/" + selectedLabId;
    return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
        error.url = url;
    }));
  }

  getSenderSpecificKits(selectedLabId: string, active: boolean): Observable<BBResponseContainer> {
      let url = environment.BB_MDMSERVICE_URL + this.KITMDMSERVICE + '/listBasedOnPCRAndExtraction';
      let requestParam = new HttpParams().set('labId', selectedLabId).set('active', active.toString());
      const options = url ? { params: requestParam } : {};
      return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
    }));
  }

  getResultConfigList(lab: LabMDM): Observable<BBResponseContainer> {
    let url = environment.BB_MDMSERVICE_URL + this.RESULTENGINECONFIGSERVICE;
    let requestParam = new HttpParams().set('labId', lab._id);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url,options).pipe(tap(event => { }, error => {
        error.url = url;
    })); 
  }
  getResultConfigNames(lab: string,kitLot: string) {
    let url = environment.BB_MDMSERVICE_URL + "resultConfig/getResultConfigNames/" + lab;
    let requestParam = new HttpParams().set('kit', kitLot);
    const options = url ? { params: requestParam } : {};
    return this.http.get<any>(url, options).pipe(timeout(environment.defaultTimeout));
  }

  getResultForKitCyclerResultCombo(selectedLabId: string, kitCyclerResultCombo: string): Observable<BBResponseContainer> {
    let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/resultConfigExistence';
    let requestParam = new HttpParams().set('labId', selectedLabId).set('kitNameCyclerResultName', kitCyclerResultCombo);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url,options).pipe(tap(event => { }, error => {
        error.url = url;
    })); 
  }

  addResultLogic(resultLogic: ResultConfigDTO): Observable<BBResponseContainer> {
    let url = environment.BB_MDMSERVICE_URL + this.RESULTENGINECONFIGSERVICE;
    return this.http.post<BBResponseContainer>(url, resultLogic).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
    })); 
  }

  updateResultLogic(resultLogic: ResultConfigDTO): Observable<BBResponseContainer> {
    let url = environment.BB_MDMSERVICE_URL + this.RESULTENGINECONFIGSERVICE;
    return this.http.put<BBResponseContainer>(url, resultLogic).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
    })); 
  }

  getNamesForMachinesWithTypes(type: string, lab: string, active: boolean): Observable<BBResponseContainer> {
    let url = environment.BB_MDMSERVICE_URL + this.MACHINEMDMSERVICE + '/names/' + lab + '/' + active + '/' + type;
    return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
    })); 
  }

    getKitsFromMDM(labID: string, swabRestriction: string, extractorKits: string, pcrKits: string): Observable<BBResponseContainer> {
    let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/kits/kitTypes' + '/' + labID + '/' + swabRestriction;
    let requestParam = new HttpParams().set('extractorKits', extractorKits).set('pcrKits', pcrKits);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }

    //Get all the external sender logins configured for the lab
    getExternalSenderLogins(lab: LabMDM): Observable<BBResponseContainer> {

        let url = environment.BB_MDMSERVICE_URL + this.EXTERNALSENDERLOGINSERVICE;
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    addExternalSenderLogin(externalSenderLogin: ExternalSenderLoginDTO): Observable<BBResponseContainer>{
        let url = environment.BB_MDMSERVICE_URL + this.EXTERNALSENDERLOGINSERVICE;
        return this.http.post<BBResponseContainer>(url, externalSenderLogin).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        }));
    }

    updateExternalSenderLogin(externalSenderLogin: ExternalSenderLoginDTO): Observable<BBResponseContainer>{
        let url = environment.BB_MDMSERVICE_URL + this.EXTERNALSENDERLOGINSERVICE;
        return this.http.put<BBResponseContainer>(url, externalSenderLogin).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        }));
    }

  getManufacturerList(labId:string): Observable<BBResponseContainer>{
    let url = environment.BB_MDMSERVICE_URL + this.MANUFACTURERSERVICE;
    let requestParam = new HttpParams().set('labId', labId);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url,options).pipe(tap(event => { }, error => {
        error.url = url;
    }));
  }
  updateManufacturer(selectedMasterList: Manufacturers) {
    let url = environment.BB_MDMSERVICE_URL + this.MANUFACTURERSERVICE;
   return this.http.put<BBResponseContainer>(url,selectedMasterList).pipe(tap(event => { }, error => {
        error.url = url;
    })); 
  }
  saveManufacturer(selectedMasterList: Manufacturers) {
    let url = environment.BB_MDMSERVICE_URL + this.MANUFACTURERSERVICE;
    return this.http.post<BBResponseContainer>(url,selectedMasterList).pipe(tap(event => { }, error => {
        error.url = url;
    })); 
  }
   getActiveMachineTypes(active:boolean,labId:string){
    let url = environment.BB_MDMSERVICE_URL + this.MACHINETYPEMDMSERVICE;
    let requestParam = new HttpParams().set('active', active.toString()).set("labId",labId);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
    }));
  }

  getPattersFromManufacturer(manufacturerName:string, labId: string){
    let url = environment.BB_MDMSERVICE_URL + this.MANUFACTURERSERVICE + '/' + manufacturerName;
    let requestParam = new HttpParams().set("labId",labId);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
    }));
  }

    getManufacturesFromMachineTypeAndLabId(machineType: string, labId: string) {
        let url = `${environment.BB_MDMSERVICE_URL}${this.MANUFACTURERSERVICE}/${labId}/${machineType}`;
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
    }
    getKitImage(kitName, imageName: string) {
        let url: string = environment.BB_MDMSERVICE_URL + this.KITMDMSERVICE+"/getKitImage/";
        let requestParam = new HttpParams().set('kitName',kitName). set('imageName',imageName);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
      }
    getRedoReasons(lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.REDOREASON;
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }
    saveRedoReason(redoReason: RedoReason) {
        let url = environment.BB_MDMSERVICE_URL + this.REDOREASON;
        return this.http.post<BBResponseContainer>(url, redoReason).pipe(timeout(environment.defaultTimeout));
    }
    updateRedoReason(redoReason: RedoReason) {
        let url = environment.BB_MDMSERVICE_URL + this.REDOREASON;
        return this.http.put<BBResponseContainer>(url, redoReason).pipe(timeout(environment.defaultTimeout));
    }
    getInboundFileProcessing(lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.INBOUNDFILEPROCESSING;
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }
    saveInboundFileProcessing(inboundFileProcessing: InboundFileProcessing) {
        let url = environment.BB_MDMSERVICE_URL + this.INBOUNDFILEPROCESSING;
        return this.http.post<BBResponseContainer>(url, inboundFileProcessing).pipe(timeout(environment.defaultTimeout));
    }
    updateInboundFileProcessing(inboundFileProcessing: InboundFileProcessing) {
        let url = environment.BB_MDMSERVICE_URL + this.INBOUNDFILEPROCESSING;
        return this.http.put<BBResponseContainer>(url, inboundFileProcessing).pipe(timeout(environment.defaultTimeout));
    }

    getKitByName(lab, kitName, kitType: string) {
        let url: string = environment.BB_MDMSERVICE_URL + this.KITMDMSERVICE+"/kitName";
        let requestParam = new HttpParams().set('lab',lab). set('kitName',kitName). set('kitType',kitType);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
      }
      
    createWorkFlow(json: string,labId: string,entityName:string){
        let url: string = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM_WORKFLOW+"/"+labId+"/"+entityName;
        return this.http.post<BBResponseContainer>(url, json).pipe(timeout(environment.defaultTimeout));
    }

    getWorkFlow(labId: string){
        let url: string = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM_WORKFLOW+"/"+labId+"/workflow/list?pageNumber=0&limit=100";
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
    }

    updateWorkFlow(json:string,labId: string,id:string){
        let url: string = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM_WORKFLOW+"/"+labId+"/workflow/"+id;
        return this.http.put(url, json).pipe(timeout(environment.defaultTimeout));
    }

    saveControlConfiguration(lab: LabMDM, controls) {
        let url = environment.BB_MDMSERVICE_URL + this.ADMIN_MDM_GENERIC + "/" + lab._id + "/" + "controls";
        return this.http.post<BBResponseContainer>(url, controls).pipe(timeout(environment.defaultTimeout));
    }

    updateControlConfiguration(lab: LabMDM, controls) {
        let url = environment.BB_MDMSERVICE_URL + this.ADMIN_MDM_GENERIC + "/" + lab._id + "/" + "controls" + "/" + controls._id;
        return this.http.put<Controls>(url, controls).pipe(timeout(environment.defaultTimeout));
    }

    getControlConfiguration(lab: LabMDM, controls) {
        let url = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM + "/" + lab._id + "/" + controls + "/list";
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
    }

    getActiveControls(lab: string, controls) {
        let url = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM + "/" + lab + "/" + controls + "/list?activeIndicator=true";
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
    }

    getAllActiveWorkFlow(labId: string){
        let url: string = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM_WORKFLOW+"/"+labId+"/workflow/list?activeIndicator=true";
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
    }

    getBatchStatus(labId: string){
        let url: string = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM_BATCHSTATUS+"/"+labId+"/batchstatus/list?pageNumber=0&limit=100";
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
    }
    
    createBatchStatus(json: string,labId: string,entityName:string){
        let url: string = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM_BATCHSTATUS+"/"+labId+"/"+entityName;
        return this.http.post<BBResponseContainer>(url, json).pipe(timeout(environment.defaultTimeout));
    }
       
    updateBatchStatus(json:string,labId: string,id:string){
        let url: string = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM_BATCHSTATUS+"/"+labId+"/batchstatus/"+id;
        return this.http.put(url, json).pipe(timeout(environment.defaultTimeout));
    }
    createParentageAnalysis(json: string,labId: string,entityName:string){
        let url: string = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM_PARENTAGE+"/"+labId+"/"+entityName;
        return this.http.post<BBResponseContainer>(url, json).pipe(timeout(environment.defaultTimeout));
    }
       
    updateParentageAnalysis(json:string,labId: string,id:string){
        let url: string = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM_PARENTAGE+"/"+labId+"/parentageAnalysis/"+id;
        return this.http.put(url, json).pipe(timeout(environment.defaultTimeout));
    }
    getParentageAnalysis(labId: string){
        let url: string = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM_PARENTAGE+"/"+labId+"/parentageAnalysis/list?pageNumber=0&limit=100";
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
    }
}
